<div class="app-layout-host">
  <div class="app-layout">
    <header class="app-layout__top">
      <app-top-navbar [publicLegal]="false" />
    </header>

    <app-maintenance-banner />

    <div class="app-layout__body">
      <aside class="app-layout__side" aria-label="Side navigation">
        <app-side-navbar />
      </aside>

      <main class="app-layout__main">
        <div class="app-layout__main-content">
          <router-outlet />
        </div>
        <footer class="app-layout__footer">
          <app-footer />
        </footer>
      </main>
    </div>

    <p-toast class="app-layout__overlay" />
    <app-edit-user-profile class="app-layout__overlay" />
  </div>
</div>
